import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import routes from './routes'

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    /**
   * To keep the scroll position when route cha
   */
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // We have savedPosition mostly if moving back.
            return savedPosition;
        } else {
            // Pass in query parameter top=1 to keep scroll to top.
            if (to.query.top) return { x: 0, y: 0 };
        }
    },
})

export default router
